import { createApp } from '@backstage/frontend-defaults';
import type { FrontendFeature } from '@backstage/frontend-plugin-api';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import authPlugin from '@backstage/plugin-auth';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
// import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { catalogPlugin } from './modules/catalog/catalogNavItemOverride';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import orgPlugin from '@backstage/plugin-org/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import snykPlugin from 'backstage-plugin-snyk/alpha';
import searchPlugin from '@backstage/plugin-search/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import visualizerPlugin from '@backstage/plugin-app-visualizer';
import homePlugin from '@backstage/plugin-home/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';

import { cerebroAppModule } from './modules/app/cerebroAppModule';
import { cerebroHomeModule } from './modules/home/cerebroHomeModule';
import { entityPageFeatures } from './modules/catalog/entityPageModule';
import { cerebroUserSettingsModule } from './modules/user-settings/cerebroUserSettingsModule';
import { shortcutsApiModule } from './modules/shortcuts/shortcutsApiModule';
import { rithumAgentAppModule } from './modules/rithum-agent/rithumAgentAppModule';
import { jiraPlugin } from '@internal/plugin-jira';
import { navModule } from './modules/nav';
import { catalogAnnotationsApiModule } from './modules/catalog-annotations/catalogAnnotationsApiModule';
import { rithumAiPlugin } from '@internal/backstage-plugin-rithum-ai';
import { rithumAiReadinessPlugin } from '@internal/backstage-plugin-rithum-ai-readiness';

export default createApp({
  features: [
    authPlugin,
    cerebroAppModule,
    catalogPlugin,
    ...entityPageFeatures,
    apiDocsPlugin,
    catalogImportPlugin,
    catalogGraphPlugin,
    orgPlugin,
    scaffolderPlugin,
    searchPlugin,
    techdocsPlugin,
    userSettingsPlugin,
    cerebroUserSettingsModule,
    notificationsPlugin,
    signalsPlugin,
    kubernetesPlugin,
    // Community alpha export omits `info`; runtime matches other FrontendPlugins.
    githubActionsPlugin as unknown as FrontendFeature,
    snykPlugin,
    visualizerPlugin,
    homePlugin,
    cerebroHomeModule,
    shortcutsApiModule,
    rithumAgentAppModule,
    jiraPlugin,
    navModule,
    catalogAnnotationsApiModule,
    rithumAiPlugin,
    rithumAiReadinessPlugin,
  ],
  bindRoutes({ bind }) {
    bind(catalogPlugin.externalRoutes, {
      createComponent: scaffolderPlugin.routes.root,
      viewTechDoc: techdocsPlugin.routes.docRoot,
      createFromTemplate: scaffolderPlugin.routes.selectedTemplate,
    });
    bind(apiDocsPlugin.externalRoutes, {
      registerApi: catalogImportPlugin.routes.importPage,
    });
    bind(scaffolderPlugin.externalRoutes, {
      registerComponent: catalogImportPlugin.routes.importPage,
      viewTechDoc: techdocsPlugin.routes.docRoot,
    });
    bind(orgPlugin.externalRoutes, {
      catalogIndex: catalogPlugin.routes.catalogIndex,
    });
  },
});
